import { error } from 'loglevel';
// @ts-ignore
import api from 'src/utils/api';
import { getCommunityBannerUrl, getCommunityLogoUrl } from 'src/utils/linkUtils';
import { CurrentUser } from 'src/types';

const isMember = (user: CurrentUser, communitySlug: string) => {
  return user && user.followedCommunities.some(c => c.slug === communitySlug);
};

export const fetchCommunity = async function (api: any, user: CurrentUser, communitySlug: string) {
  const showPrivate = isMember(user, communitySlug);

  const { data } = await api.get(`${showPrivate ? 'private/' : ''}communities/${communitySlug}`);
  return data;
};

export const fetchCommunityAbout = async function (api: any, user: CurrentUser, communitySlug: string) {
  const showPrivate = isMember(user, communitySlug);
  const { data } = await api.get(`${showPrivate ? 'private/' : ''}communities/${communitySlug}/about`);
  return data;
};

export const saveAndCropLogoImage = async (slug: string, formData: FormData) => {
  const { data: { imageHash } } = await api.post('private/images/group-logos', formData);

  // updates community logo with new image
  const response = await api.put(`private/communities/${slug}/logo`, {
    logoImageHash: imageHash,
  });

  const imageUrl = getCommunityLogoUrl(imageHash);
  return { response, imageUrl };
};

export const saveAndCropBannerImage = async (slug: string, formData: FormData) => {
  const { data: { imageHash } } = await api.post('private/images/group-banners', formData);

  // updates community banner with new image
  const response = await api.put(`private/communities/${slug}/banner`, {
    bannerImageHash: imageHash,
  });

  const imageUrl = getCommunityBannerUrl(imageHash);
  return { response, imageUrl };
};

export const removeMemberFromCommunity = async (slug: string, userId: number) => {
  try {
    const response = await api.del(`private/communities/${slug}/member/${userId}`);
    return response;
  } catch (ex) {
    error(ex);
    return ex.response; // BE returns several failure messages to display on FE
  }
};
